import { ArrowRight, MonitorPlay, Rocket } from "lucide-react";
import { Link } from "react-router-dom";
import heroVisual from "../../assets/images/main-bg.png";
import ResponsiveImage from "../common/ResponsiveImage";

const SectionWebsiteHero: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fff_0%,#fff5f5_100%)] py-7 sm:py-9 lg:pb-10 lg:pt-2">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[-56px] top-4 h-40 w-40 rounded-full bg-red-100/60 blur-3xl sm:h-44 sm:w-44 lg:h-48 lg:w-48" />
        <div className="absolute bottom-[-24px] right-[-56px] h-52 w-52 rounded-full bg-rose-100/60 blur-3xl sm:h-56 sm:w-56 lg:h-60 lg:w-60" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="grid items-center gap-8 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-12">
          <div className="text-left">
            <span className="inline-flex items-center rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
              Dịch vụ thiết kế website
            </span>

            <h1 className="mt-5 max-w-[760px] text-[30px] font-semibold leading-[1.12] text-[#2f1a1a] sm:text-[38px] lg:text-[48px]">
              Thiết Kế Website Chuyên Nghiệp, Chuẩn Chuyển Đổi Và Sẵn Sàng Mở Rộng
            </h1>

            <p className="mt-5 max-w-[700px] text-[15px] leading-8 text-slate-600 sm:text-[16px]">
              TrioCore Solutions xây dựng website theo định hướng kinh doanh thực tế: đẹp, rõ giá trị,
              dễ dùng trên mọi thiết bị và đủ chắc để mở rộng thành nền tảng bán hàng, marketing hoặc
              vận hành nội bộ về sau.
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a href="#contact-section">
                <button className="button-primary h-[46px] w-full min-w-[210px] px-6 sm:w-auto">
                  Nhận tư vấn thiết kế web
                </button>
              </a>

              <Link to="/store/website">
                <button className="button-secondary h-[46px] w-full min-w-[210px] px-6 sm:w-auto">
                  Xem mẫu giao diện
                </button>
              </Link>
            </div>

            <div className="mt-8 grid gap-3 sm:grid-cols-3">
              {[
                { label: "Responsive", icon: MonitorPlay },
                { label: "SEO kỹ thuật", icon: Rocket },
                { label: "Mở rộng linh hoạt", icon: ArrowRight },
              ].map(({ label, icon: Icon }) => (
                <div
                  key={label}
                  className="flex items-center gap-3 rounded-2xl border border-red-100 bg-white/90 px-4 py-3 shadow-[0_12px_30px_rgba(127,29,29,0.05)]"
                >
                  <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-red-50 text-red-600">
                    <Icon size={18} />
                  </div>
                  <span className="text-[14px] font-medium text-[#2f1a1a]">{label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-[470px] lg:max-w-[440px] xl:max-w-[470px]">
            <ResponsiveImage
              src={heroVisual}
              alt="Website design TrioCore Solutions"
              className="h-auto w-full object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWebsiteHero;
